(function($) {
  let url = window.location.href;
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ General
  function Resetoverlays() {
    $('.sidebar-r').removeClass('open');
    $('body').removeClass('no-scroll');
    $(".barre-de-recherche").removeClass("active");
    $('#volet-eshop').addClass('hide');
    $(".entete-bloc").removeClass("shrink");
    $(".entete-bloc").removeClass("static");
    $('.hamburger-icon').removeClass('hamburger-icon-open');
    $('.mobile-nav').removeClass('active');
    $('.calendly').removeClass('open');
    $('.echantillons').removeClass('open');
    $('.contact-volet').removeClass('open');
  }
  $('.sidebar-head .close').click(function() {
    Resetoverlays();
  });
  $('.sidebar-close').click(function() {
    Resetoverlays();
  });
  $('.sidebar-r .sidebar-footer .exit').click(function() {
    Resetoverlays();
  });
  $('.bg-img').each(function(e) {
    var bg_ = 'url(' + $(this).children('img').attr('src') + ')';
    $(this).children('img').hide();
    $(this).css('background-image', bg_);
  });
  $('.bg-img-pro').each(function(e) {
    var bg_ = 'url(' + $(this).children('img').attr('src') + ')';
    $(this).children('img').hide();
    $(this).css('background-image', bg_);
  });
  $('.page-overlay').click(function() {
    Resetoverlays();
  });
  $('.filtre .etiquette').on("click", function() {
    $(this).siblings().each(function() {
      $(this).removeClass('active');
    });
    $(this).addClass('active');
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ header.liquid
  $(document).on("scroll", function() {
    if($(document).scrollTop() > 5) {
      $(".entete-bloc").addClass("shrink", 1000);
    } else {
      $(".entete-bloc").removeClass("shrink", 1000);
    }
    if($(document).scrollTop() > 300) {
      $(".entete-bloc").removeClass("shrink", 2000);
      $(".entete-bloc").addClass("shrink2", 2000);
    } else {
      $(".entete-bloc").removeClass("shrink2", 2000);
    }
  });
  let lastScrollTop = 0;  
  $(window).scroll(function() {
    let st = $(this).scrollTop();
    if (st > lastScrollTop || st == 0) {
      $('.entete-bloc').addClass('scrolling-down');
      $('.entete-bloc').removeClass('scrolling-up');
      $('body').removeClass('scroll-up');
    } else {
      $('.entete-bloc').addClass('scrolling-up');
      $('.entete-bloc').removeClass('scrolling-down');
      $('body').addClass('scroll-up');
    }
    lastScrollTop = st;
  });
  
  $('.hamburger-icon').click(function() {
    if($(this).hasClass('hamburger-icon-open')) {
      Resetoverlays();
      return false;
    }
    Resetoverlays();
    $(this).addClass('hamburger-icon-open');
    $('.mobile-nav').addClass('active');
    $(".entete-bloc").addClass("static");
    $('body').addClass('no-scroll');
  });
  $('.cart-icon').click(function() {
    Resetoverlays();
    $('.cart-sidebar').addClass('open');
    $('body').addClass('no-scroll');
  });
  $('.calendly-link').click(function() {
    Resetoverlays();
    $('.calendly').addClass('open');
    $('body').addClass('no-scroll');
  });
  $('.echantillons-link').click(function() {
    Resetoverlays();
    $('.echantillons').addClass('open');
    $('body').addClass('no-scroll');
  });
  $('.contact-link').click(function() {
    Resetoverlays();
    $('.contact-volet').addClass('open');
    $('body').addClass('no-scroll');
  });
  $(".search-icon").click(function() {
    Resetoverlays();
    $('body').addClass('no-scroll');
    $(".barre-de-recherche").addClass("active");
    $(".barre-de-recherche .form-control").focus();
  });
  $('.barre-de-recherche .croix').click(function() {
    Resetoverlays();
  });
  $('.eshop-menu').click(function() {
    if(!$('#volet-eshop').hasClass('hide')) {
      Resetoverlays();
      return false;
    }
    Resetoverlays();
    $('body').addClass('no-scroll');
    $('#volet-eshop').removeClass('hide');
    $(".entete-bloc").addClass("static");
    $('.eshop-slide').slick("refresh");
    $(window).trigger('resize');
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ footer.liquid
  $(window).on('scroll', function () {
    let margin_start = 50;
    let scroll_start = $(this).height() / 2;
    
    let scroll_length = $('html').height() - $(this).scrollTop() - $(this).height();
    let scroll_progress = Math.min(Math.max(scroll_length, 0), scroll_start) / scroll_start;
    let margin = margin_start * scroll_progress;
    
    $('.footer-logo.empiete').css('margin-top', '-' + margin + 'lvh');
    $('.footer-logo.empiete').css('padding-bottom', margin + 'lvh');
  });
  
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ volet-eshop.liquid
  $('.eshop-slide').slick({
    infinite: true,
    dots:false,
    arrows: true,
    slidesToShow: 3,
    centerMode: true,
    initialSlide: 1
  });
  $('.el-link').click(function() {
    if($(this).hasClass('dead')) {
      return;
    }
    if($(this).hasClass('activated')) {
      if($(this).attr('data-redirect')) {
        window.location.href = $(this).attr('data-redirect');
      }
    } else {
      $(this).closest('.eshop-liste').find('.el-link').removeClass('activated');
      $(this).addClass('activated');
      $(this).closest('.volet-eshop').find('.eshop-items').addClass('hide');
      $(this).closest('.volet-eshop').find('.eshop-items[data-item="' + $(this).attr('data-item') + '"]').removeClass('hide');
      $('.e-slide').slick("refresh");
      $(window).trigger('resize');
    }
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ hero-section.liquid
  $('.hero-slide').slick({
    infinite: true,
    dots:true,
    arrows:false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover:false
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ main-list-collections.liquid
  $('.collection-slide').slick({
    infinite: true,
    arrows: true,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    slidesToScroll: 1,
    cssEase: "ease-out",
    speed: 300
  });
  $('.collection-slide').on('wheel', (function(event) {
    event.preventDefault();
    const scroll_padding = 50;
    if (event.originalEvent.deltaY < 0-scroll_padding) $(this).slick('slickPrev');
    else if(event.originalEvent.deltaY > 0+scroll_padding) $(this).slick('slickNext');
  }));

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ main-collection-banner
  $(document).on("scroll", function() {
    if($(document).scrollTop() <= 1) {
      $('.collection-arrow').removeClass('hide');
    } else if($(document).scrollTop() > 1) {
      $('.collection-arrow').addClass('hide');
    }
  });
  $('.collection-arrow').click(function() {
    $(this).addClass('hide');
  });
  $('.collection-images').slick({
    infinite: true,
    dots:false,
    arrows:true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover:false
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ main-product.liquid
  if ($(window).width() <= 767) {
    $('.produit-images').slick({
      infinite: true,
      dots:true,
      arrows:false
    });
    $('.fleche3D').addClass('hide');
  }
  $(window).resize(function() {
    if($(this).width() <= 767) {
      $('.produit-images').slick({
        infinite: true,
        dots:true,
        arrows:false
      });
      $('.fleche3D').addClass('hide');
    } else {
      $('.produit-images').slick('unslick');
      $('.fleche3D').removeClass('hide');
    }
  });
  $('.mere-slide').slick({
    infinite: true,
    dots:false,
    arrows:true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover:false
  });
  $('.produit-images').magnificPopup({
    delegate: 'img',
    type: 'image',
    gallery: {
      enabled: true,
    },
    zoom: {
      enabled: true,
      duration: 150,
      easing: 'ease'
    },
    callbacks: {
      elementParse: function(item) {
        item.src = item.el.attr('src');
      },
      change: function(item) {
        this.content[0].children[2].href = this.content[0].children[1].src;
        this.content[0].children[1].onclick = function() {
          $(this).toggleClass('mfp-zoom-around');
          $(this).css('max-width', 'none');
          $(this).css('max-height', window.innerHeight);
          $(this).css('width', 'auto');
          $(this).css('height', 'auto');
          $(this).css('transform', 'translate(0px, 0px)');
        }
      }
    }
  });
  $('.guide').magnificPopup({
    type: 'image',
    callbacks: {
      change: function(item) {
        this.content[0].children[2].href = this.content[0].children[1].src;
        this.content[0].children[1].onclick = function() {
          $(this).toggleClass('mfp-zoom-around');
          $(this).css('max-width', 'none');
          $(this).css('max-height', window.innerHeight);
          $(this).css('width', 'auto');
          $(this).css('height', 'auto');
          $(this).css('transform', 'translate(0px, 0px)');
        }
      }
    }
  });
  $('.mere-slide').magnificPopup({
    delegate: 'img',
    type: 'image',
    gallery: {
      enabled: true,
    },
    zoom: {
      enabled: true,
      duration: 150,
      easing: 'ease'
    },
    callbacks: {
      elementParse: function(item) {
        item.src = item.el.attr('src');
      },
      change: function(item) {
        this.content[0].children[2].href = this.content[0].children[1].src;
        this.content[0].children[1].onclick = function() {
          $(this).toggleClass('mfp-zoom-around');
          $(this).css('max-width', 'none');
          $(this).css('max-height', window.innerHeight);
          $(this).css('width', 'auto');
          $(this).css('height', 'auto');
          $(this).css('transform', 'translate(0px, 0px)');
        }
      }
    }
  });
  $('.lien-configurateur').click(function() {
    $('.volet-configurateur').toggleClass('open');
    $('body').toggleClass('no-scroll');
    let target = $(this).attr('data-option');
    if(!$('.volet-configurateur .accordion li').has('a.' + target).hasClass('active')) $('.volet-configurateur .accordion li a.' + target).click();
  });
  $('.lien-description').click(function() {
    $('.volet-description').toggleClass('open');
    $('body').toggleClass('no-scroll');
    if(!$('.volet-description .accordion li:first-child').hasClass('active')) $('.volet-description .accordion li:first-child a').click();
  });
  $('.lien-livraison').click(function() {
    $('.volet-description').toggleClass('open');
    $('body').toggleClass('no-scroll');
    if(!$('.volet-description .accordion li:last-child').hasClass('active')) $('.volet-description .accordion li:last-child a').click();
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ cellule-produit-*.liquid
  let cellule_produit = [];
  let produit_existe = false;
  let cadre_html = '';
  $('.cellule-produit .image .cadre a').on("mouseenter", function() {
    $(this).closest('.cellule-produit').find('.info .prix').html($(this).data("prix"));
    $(this).closest('.cellule-produit').find('.image .3D').attr("src", $(this).data("image"));
    $(this).closest('.cellule-produit').find('.image .lien').attr("href", $(this).attr("href"));
    $(this).closest('.cellule-produit').find('.info a').attr("href", $(this).attr("href"));
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ picto-section.liquid
  $('.psb_available').click(function() {
    let sidebar = $(this).closest('.picto-section').next('.picto-sidebar');
    sidebar.find('.picto-sidebar-text').removeClass('selected');
    sidebar.find('.picto-sidebar-text[data-id="' + $(this).attr("data-id") + '"]').addClass('selected');
    sidebar.addClass('open');
    $('body').toggleClass('no-scroll');
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ fabrics-1.liquid
  $('.tissu-slide').slick({
      infinite: true,
      dots:false,
      arrows:true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover:false
    });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Aide-2.liquid & Legal-2.liquid
  $(".archive-tab li").on("click", function () {
    var target = $(this).attr("data-rel");
    $(".archive-tab li ").removeClass("active");
    $(this).addClass("active");
    $("#" + target).fadeIn("slow").siblings(".fade-tab").hide();
    $(".archive-slide").slick("refresh");

    $(this).parents("ul").removeClass("open");
    $(this).parents(".archive-tab").find("#selectvalue span").html($(this).text());
    $(this).parents(".archive-tab").find("#selectvalue span").val($(this).data("value"));
  });
  $(".mobile-select-value").click(function () {
  	$(this).next("ul").toggleClass("open");
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Newsletter ?
  $(document).ready(function() {
    $('#close').click(function() {
      $.magnificPopup.close();
    });
    $('a[href="#open-popup"]').click(function() {
      $.magnificPopup.open({
        items: {
          src: "#newsletter-modal",
        },
        type: "inline"
      });
    });
  });

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ ???
  $(window).load(function(){
    if (window.location.href.indexOf("#") > -1) {
      window.location.href = window.location.href.split('#')[0];
    }
  });
})(jQuery);